import { MobileHelper } from '@rightship-tech/common-ui/helpers/mobile-helper';
import { IPaginationPage } from '@rightship-tech/common-ui/components/comp-pagination/comp-pagination.models';
import { CompListMenuItem } from '@rightship-tech/common-ui/components/comp-list-menu/comp-list-menu.models';
import { Router } from 'aurelia-router';
import { autoinject, transient, observable } from "aurelia-framework";
import { LookupValue } from "@rightship-tech/common-ui/models/lookup.models";
import { GetTasksRequest, GetTasksResponse, TaskModel, TaskPriorityEnum } from "@rightship-tech/tasks-ui/models/tasks.models";
import { ItemSource, SourceType, DataType } from '@rightship-tech/common-ui/models/queries.models';
import { ConfigService } from '@rightship-tech/common-ui/services/basic/config.service';
import { DataGridColumn } from '@rightship-tech/common-ui/components/comp-data-grid/comp-data-grid.models';
import { MyVesselService } from '../../../../services/my-vessel.service';
import { MyTasksService } from '../../../../services/my-tasks.service';
import { GetVesselsResponse } from '../../../../models/myvessels.models';
import { MyVesselsRouteConstants } from '../../../../constants/route.constants';
import moment from "moment";
import { TaskActionService } from '../../../../services/task-action.service';
import { UserClaimsService } from '@rightship-tech/common-ui/services/basic/user-claims.service';
import { Claims } from '@rightship-tech/common-ui/constants/authentication/claims';
import { RightStoreService } from '@rightship-tech/common-ui/services/rightstore/rightstore.service';
import { CustomerSubscriptionModel } from '@rightship-tech/common-ui/models/rightstore/rightstore.models';
import { CustomerService } from '@rightship-tech/common-ui/services/basic/customer-client.service';
import { ProductCodes } from '@rightship-tech/tasks-ui/constants/product.constant';
import { EntityTypes } from '@rightship-tech/common-ui/models/basic.models';
import { UserClientService } from '@rightship-tech/common-ui/services/basic/user-client.service';
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { QuoteService } from '../../../../services/rightstore/quote.service';
import { CreateRequestForQuote } from '../../../../models/quote.models';
import { SelectVesselTypeEnum } from '../../../../models/common.models';
import * as MyVesselsClaims from "../../../../constants/claims.constants";

@autoinject
@transient()
export class AllTasks implements IPaginationPage {

	@observable
	public currentPage: number = 1;

	@observable
	private vessels: LookupValue[] = [];

	public isMobileFilterOpen: boolean;
	public lastPage: number;
	// public statuses: LookupValue[] = [];
	public itemSource: ItemSource = null;
	public menuItems: CompListMenuItem[] = [
		{
			item: "Submit missing PSC",
			click: () => this.submitMissingPsc(),
			classList: '',
			isVisible: true,
		},
		{
			item: "Submit Class Status Report",
			click: () => this.submitClassStatusReport(),
			classList: '',
			isVisible: true,
		},
		{
			item: "Submit Change of Management",
			click: () => this.submitChangeOfManagement(),
			classList: '',
			isVisible: true,
		},
		{
			item: "Request RightShip Inspection",
			click: () => this.requestRightShipInspection(),
			classList: '',
			isVisible: true,
		}
	];
	public isRightShipUser: boolean;
	public showDocumentRequirements: boolean;
	public customerSubscription: CustomerSubscriptionModel;
	public isCustomerFullSubscription: boolean;
	public customerSubscriptionVessels: any;

	initFilter = () => {
		return {
			"priority": {
				"count": this.filter?.priority?.count ?? 0,
				"selected": false
			},
			"date": {
				"selected": false,
				"expanded": false,
				"startDate": null,
				"endDate": null
			},
			"vessels": {
				"selected": [],
				"expanded": false
			},
			"psc": {
				"count": 0,
				"selected": false
			},
			"inc": {
				"count": 0,
				"selected": false
			},
			"cfr": {
				"count": 0,
				"selected": false
			},
			"fbr": {
				"count": 0,
				"selected": false
			},
			"env": {
				"count": 0,
				"selected": false
			},
			"insp": {
				"count": 0,
				"selected": false
			},
			"forms": {
				"count": 0,
				"selected": false
			},
			"mouDataVerification": {
				"count": 0,
				"selected": false
			},
			"documentRequirements": {
				"count": 0,
				"selected": false
			}
			// ,
			// "status": {
			// 	"selected": [1, 3],
			// 	"expanded": false
			// }
		};
	}

	private filter = this.initFilter();

	constructor(private router: Router, private myTaskService: MyTasksService, private configService: ConfigService,
		private vesselService: MyVesselService, private taskActionService: TaskActionService, private userClaimsService: UserClaimsService,
		private rightStoreService: RightStoreService, private customerService: CustomerService,
		private userClientService: UserClientService, private notificationClientService: NotificationClientService,
		private quoteClientService: QuoteService) { }

	activate() {

		//Get my vessels
		this.vesselService.getMyVessels().then((response: GetVesselsResponse) => {

			//Map vessels
			this.vessels = response?.result.map((vessel) => {
				return {
					id: vessel.vesselId,
					name: vessel.identifier + "    " + vessel.vesselName
				};
			});

		});

		//Filter tasks
		this.filterTasks(true);

		//Bind priority count
		this.myTaskService.getAllTask(
			{
				vessels: this.vessels.map((vessel) => vessel.id),
				statuses: [],
				priority: 1,
				rowPerPage: 10,
				orderBy: "ASC",
				sortBy: "Date"
			}).then((response: GetTasksResponse) => {
				this.filter.priority.count = response.rowCount;
			});

		//Get task statuses
		// this.taskService.getTaskStatus().then((response: any[]) => {
		// 	this.statuses = response?.map((item) => {
		// 		return {
		// 			id: item.id,
		// 			name: item.name
		// 		};
		// 	});
		// });

		this.bindCounts();
		this.isRightShipUser = this.userClaimsService.hasPermission(Claims.RightShipUser);
		this.showDocumentRequirements = this.userClaimsService.hasPermission(MyVesselsClaims.Claims.ShowDocumentRequirementInHome);
	}

	async attached() {
		this.isCustomerFullSubscription = await this.getCustomerFullSubscription();
		this.customerSubscriptionVessels = await this.rightStoreService.getCustomerSubscriptionVessels(this.customerSubscription?.customerSubscriptionId)
	}

	//Priority filter clicked
	priorityFilterClicked = (filterNow: Boolean = true) => {
		this.filter.priority.selected = !this.filter.priority.selected;

		//If mobile don't filter now, will be done later
		if (filterNow) {
			this.filterTasks(true);
		}
	}

	//Date filter clicked
	dateFilterClicked = (event) => {

		//Show notification if end date is smaller than start date
		if (this.filter.date.startDate && this.filter.date.endDate && this.filter.date.startDate > this.filter.date.endDate) {
			// this.notificationClientService.show("Can't Apply Filter", "Start Date can't be greater than End Date", NotificationType.Error);
			return;
		}

		//Set start & end dates
		this.filter.date.startDate = event.from; //two-way binding is a bit delayed when Clear is clicked
		this.filter.date.endDate = event.to; //so we set the value to make sure it is up to date

		//Set selected and expanded flags
		this.filter.date.selected = this.filter.date.startDate && this.filter.date.endDate;
		this.filter.date.expanded = false;

		//Filter tasks
		this.filterTasks(true);
	}

	//Clear all filters
	clearAllFilters = () => {
		
		//Comment to make it the same behavior as the pending tasks
		// this.filter = this.initFilter();
		// this.filter.status.selected = [];
		//Close mobile filter overlay if its open
		this.isMobileFilterOpen ? this.hideMobileFilters() : null;
		this.filter.psc.selected = false;
		this.filter.inc.selected = false;
		this.filter.cfr.selected = false;
		this.filter.fbr.selected = false;
		this.filter.insp.selected = false;
		this.filter.env.selected = false;
		this.filter.forms.selected = false;
		this.filter.mouDataVerification.selected = false;
		this.filter.documentRequirements.selected = false;
		//Filter tasks
		this.filterTasks(true);
	}

	//Open inspection form
	async requestRightShipInspection() {
		try {
			let businessUnitId = await this.customerService.getBusinessUnitId();
			let request: CreateRequestForQuote = {
				webOrderNumber: null,
				userName: this.userClientService.currentUser?.user.email || null,
				customerNumber:  businessUnitId || null,
				quoteLines: [{
					productNumber: "rightship-inspection-booking",
					status: 1,
					queryParams: ""
				}],
			};
			let response = await this.quoteClientService.getQuote(request);
			if(response?.quoteLines?.length > 0) window.open(response.quoteLines[0].url, "_blank");
		} catch (e) {
			this.notificationClientService.show("Error!", "Request RightShip Inspection Failed", NotificationType.Error);
		}
	}

	//Navigate back to previous page
	public navigateBack() {
		this.router.navigateBack();
	}

	//Check if the user can navigate back
	public canNavigateBack(): boolean {
		return this.router.history && this.router.history.getHistoryIndex() > 0;
	}

	//Submit missing PSC
	public submitMissingPsc() {
		this.router.navigateToRoute(MyVesselsRouteConstants.SelectVessel);
	}

	//Submit class status report
	private submitClassStatusReport() {
		this.router.navigateToRoute(MyVesselsRouteConstants.SelectVessel, 
			{ 
				title: "Submit Class Status Report", 
				subTitle: "Select vessel you would like to submit class status report for", 
				type: SelectVesselTypeEnum.ClassStatusReport 
			});
	}

	//Submit change of management
	private submitChangeOfManagement() {
		this.router.navigateToRoute(MyVesselsRouteConstants.SelectVessel, 
			{ 
				title: "Submit Management of Change (MoC) / Vessel Take Over Process (VTOP) Questionnaire", 
				subTitle: "Select vessel you would like to submit MoC / VTOP questionnaire for", 
				type: SelectVesselTypeEnum.ChangeOfManagement 
			});
	}

	public currentPageChanged(newValue: number, oldValue: number) {
		this.filterTasks();
	}

	//Toggle mobile filter dialog
	public toggleMobileFilterDialog() {
		this.isMobileFilterOpen = !this.isMobileFilterOpen;
	}

	//Hide mobile filter
	public hideMobileFilters() {
		this.isMobileFilterOpen = false;
	}

	//Apply all filters which where selected on mobile
	public mobileApplyAllFilters() {
		this.filterTasks(true);
		this.hideMobileFilters();
	}

	//Apply selected filters which where selected on mobile
	public mobileApplySelectedFilters() {

	}

	pscFilterClicked() {
		this.filter.psc.selected = !this.filter.psc.selected;
		this.filterTasks(true);
	}

	incFilterClicked() {
		this.filter.inc.selected = !this.filter.inc.selected;
		this.filterTasks(true);
	}

	cfrFilterClicked(refresh: boolean = true) {
		this.filter.cfr.selected = !this.filter.cfr.selected;
		if (refresh) this.filterTasks();
	}

	fbrFilterClicked(refresh: boolean = true) {
		this.filter.fbr.selected = !this.filter.fbr.selected;
		if (refresh) this.filterTasks();
	}

	envFilterClicked() {
		this.filter.env.selected = !this.filter.env.selected;
		this.filterTasks(true);
	}

	inspFilterClicked(refresh: boolean = true) {
		this.filter.insp.selected = !this.filter.insp.selected;
		if (refresh) this.filterTasks(true);
	}

	formsFilterClicked(refresh: boolean = true) {
		this.filter.forms.selected = !this.filter.forms.selected;
		if (refresh) this.filterTasks(true);
	}

	mouDataVerificationFilterClicked(refresh: boolean = true) {
		this.filter.mouDataVerification.selected = !this.filter.mouDataVerification.selected;
		if (refresh) this.filterTasks(true);
	}

	documentRequirementsFilterClicked(refresh: boolean = true) {
		this.filter.documentRequirements.selected = !this.filter.documentRequirements.selected;
		if (refresh) this.filterTasks(true);
	}

	async bindCounts() {
		let request: GetTasksRequest = {
			vessels: this.vessels?.map((vessel: LookupValue) => vessel.id),
			statuses: [],
			rowPerPage: 1,
			priority: null,
			page: 1,
			getCountByType: true,
			orderBy: "ASC",
			sortBy: "Date"
		};
		let response = await this.myTaskService.getAllTask(request);
		if (response?.countByTypes['PSC']) {

			this.filter.psc.count = parseInt(response.countByTypes['PSC']);
		}
		if (response?.countByTypes['INC']) {

			this.filter.inc.count = parseInt(response.countByTypes['INC']);
		}

		if (response?.countByTypes['CFR']) {

			this.filter.cfr.count = parseInt(response.countByTypes['CFR']);
		}

		if (response?.countByTypes['FBR']) {

			this.filter.fbr.count = parseInt(response.countByTypes['FBR']);
		}

		if (response?.countByTypes['EnvironmentalReview']) {

			this.filter.env.count = parseInt(response.countByTypes['EnvironmentalReview']);
		}
		if (response?.countByTypes['RightShipInspection']) {

			this.filter.insp.count = parseInt(response.countByTypes['RightShipInspection']);
		}
		if (response?.countByTypes['Forms']) {

			this.filter.forms.count = parseInt(response.countByTypes['Forms']);
		}
		if (response?.countByTypes['MOU Data Verification']) {

			this.filter.mouDataVerification.count = parseInt(response.countByTypes['MOU Data Verification']);
		}
		if (response?.countByTypes['DocumentRequirements']) {

			this.filter.documentRequirements.count = parseInt(response.countByTypes['DocumentRequirements']);
		}
	}

	//Filter tasks
	filterTasks(resetPage: boolean = false) {
		if (this.vessels == null) return;
		if (resetPage) this.currentPage = 1;

		//Close all filter dropdowns
		this.filter.vessels.expanded = false;
		// this.filter.status.expanded = false;
		this.filter.date.expanded = false;

		let request: GetTasksRequest = {
			vessels: this.vessels.map((vessel: LookupValue) => vessel.id),
			statuses: [],
			types: [],
			rowPerPage: 10,
			orderBy: "ASC",
			sortBy: "Date",
			page: this.currentPage
		};

		//Vessels
		if (this.filter.vessels.selected.length > 0) {
			request.vessels = this.filter.vessels.selected;
		}

		//Priority
		if (this.filter.priority.selected) {
			request.priority = 1;
		}

		//Statuses
		// if (this.filter.status.selected.length > 0) {
		// 	request.statuses = this.filter.status.selected;
		// }

		//Date
		if (this.filter.date.selected) {
			request.fromDate = this.filter.date.startDate;
			request.toDate = this.filter.date.endDate;
		}

		if (this.filter.psc.selected) {
			request.types.push(EntityTypes.PSC);
		}
		if (this.filter.inc.selected) {
			request.types.push(EntityTypes.Incident);
		}

		if (this.filter.cfr.selected) {
			request.types.push(EntityTypes.Cfr);
		}

		if (this.filter.fbr.selected) {
			request.types.push(EntityTypes.FBR);
		}
		
		if (this.filter.env.selected) {
			request.types.push(EntityTypes.GHGVerification);
		}
		if (this.filter.insp.selected) {
			request.types.push(EntityTypes.RightShipInspection);
		}

		if (this.filter.forms.selected) {
			request.types.push(EntityTypes.TVQ);
		}

		if (this.filter.mouDataVerification.selected) {
			request.mouDataVerification = true;
		}

		if (this.filter.documentRequirements.selected) {
			request.types.push(EntityTypes.DocumentRequirementSubsciptionVessels);
		}
		this.itemSource?.columns?.forEach((column: DataGridColumn) => {
			if (column.isAscending != null) {
				request.orderBy = column.isAscending ? "ASC" : "DESC";
				request.sortBy = column.name;
			}
		});

		//Get all tasks
		this.myTaskService.getAllTask(request).then((response: GetTasksResponse) => {
			this.itemSource = {
				source: response.result,
				sourceType: SourceType.Collection,
				columns: this.getColumns,
				serverSideSorting: true
			};
			this.lastPage = response?.totalPage;
		});
	}

	onSortChanged() {
		this.filterTasks();
	}

	isMouVerificationTask(task: TaskModel): boolean {
        if(task.informationMeta && task.informationMeta?.trim() != '')
        {
            if(JSON.parse(task.informationMeta)?.SubtaskTypeName == "MOU Data Verification")
            {
                return true;
            }
        }
        return false;
    }

	getColumns = [
		<DataGridColumn>{
			dataType: DataType.CustomTemplate,
			name: "vesselName",
			title: MobileHelper.isMobileDevice() ? "" : "Vessel",
			value: '<p><span class="vessel-name">${item.vesselName}</span><br/>IMO ${item.vesselImo}</p>',
			sortOrder: 1,
			columnOrder: 1,
			isSortable: true,
			isSingleColumnSorting: true,
			isHidden: false,
			width: "150px",
			instancePerRow: true,
			parameter: {
				item: null
			}
		},
		<DataGridColumn>{
			dataType: DataType.Date,
			name: "date",
			title: "Date occured",
			secondParameter: this.configService.config.common.defaultDateFormat,
			sortOrder: 1,
			columnOrder: 2,
			isSingleColumnSorting: true,
			isHidden: false,
			isSortable: true
		},
		<DataGridColumn>{
			dataType: DataType.Default,
			name: "taskTypeName",
			title: "Type",
			sortOrder: 1,
			columnOrder: 2,
			isSingleColumnSorting: true,
			isHidden: false,
			isSortable: true,
			valueConverter: (value, item: TaskModel) => {
				if (this.isMouVerificationTask(item)) {
					return "MOU Data Verification";
				}
				return value;
			}
		},
		<DataGridColumn>{
			columnOrder: 2,
			sortOrder: 3,
			dataType: DataType.Default,
			isSortable: true,
			name: 'description',
			title: 'Information',
			disableSorting: true,
			valueConverter: (value, item: TaskModel) => {
				if (this.isMouVerificationTask(item)) {
					return item.meta.MessageDetails;
				}
				return value;
			}
		},
		<DataGridColumn>{
			dataType: DataType.Default,
			name: "priorityName",
			title: "Priority",
			sortOrder: 1,
			columnOrder: 4,
			isSingleColumnSorting: true,
			isHidden: false,
			isSortable: true
		},
		<DataGridColumn>{
			dataType: DataType.CustomTemplate,
			name: "status",
			title: "Status",
			sortOrder: 1,
			columnOrder: 5,
			isHidden: false,
			isSortable: true,
			isSingleColumnSorting: true,
			instancePerRow: true,
			value: '<div class="status-badge-value">' +
				'<div class="row nowrap align-items-middle">' +
				'<div class="status-badge-dot"></div>' +
				'<p if.bind="!clickableStatus(item)">${item.status}</p>' +
				'<a class="${item.isLoading ? `is-loading`:``}" click.trigger="redirectToTaskAction(item)" if.bind="clickableStatus(item)">${getStatusTitle(item)}</a>' +
				'</div>' +
				'<span class="status-date">${getDateToString(item.statusDate)}</span>' +
				'</div>',
			width: "180px",
			getCellClass: item => {
				return (item) ? `status-badge ${this.getStatusTitle(item).toLowerCase().replace(/[^A-Za-z0-9]+/g, '-')}` : '';
			},
			parameter: {
				item: null,
				getDateToString: (date: Date | string) => {
					return moment.utc(date).local().format(this.configService.config.common.defaultDateTimeFormat);
				},
				redirectToTaskAction: this.redirectToTaskAction.bind(this),
				clickableStatus: this.clickableStatus.bind(this),
				getStatusTitle: this.getStatusTitle.bind(this)
			}
		}
	];

	//Get customer full subscription
	public async getCustomerFullSubscription() {
		let customerId = await this.customerService.getCustomerId();
        let customerSubscriptionResponse = await this.rightStoreService.getCustomerSubscription(customerId, ProductCodes.InformationServiceSubscription);
        this.customerSubscription = customerSubscriptionResponse.customerSubscription;
		return this.taskActionService.hasFullSubscription(this.customerSubscription);
	}

	//Redirects to the appropriate action based on the task type.
	async redirectToTaskAction(taskItem: TaskModel) {
		
		//If its already loading, return
		if(taskItem.isLoading) return;

		//Set loading
		taskItem.isLoading = true

		switch (taskItem.taskType) {
			case EntityTypes.PSC:
			case EntityTypes.Incident:
				if (taskItem.status == "Created")
					this.taskActionService.submitCloseOut(taskItem);
				else if (taskItem.status == "Awaiting Response") {
					let hasCloseOutSubmited = await this.taskActionService.hasCloseOutSubmited(taskItem);
					if (hasCloseOutSubmited) {
						this.taskActionService.navigateToReplyToRfi(taskItem);
					} else {
						let isPriority = taskItem.priority == TaskPriorityEnum.Standard;
						this.taskActionService.navigateToSubmitCloseOutInformation(taskItem, taskItem.orderGuid, isPriority);
					}
				}
				else if (taskItem.status == "Review Required")
					this.taskActionService.navigateToReplyToRfi(taskItem);
				break;
			case EntityTypes.GHGVerification:
				if (taskItem.status == "Pending Ship Manager Input" || taskItem.status == "Pending Ship Manager") {
					this.requestEnvironmentalReview(taskItem);
				}
				else if (taskItem.status == "Awaiting Response" ||
					taskItem.status == "Review Required") {
					this.taskActionService.navigateToReplyToRfi(taskItem);
				}
				break;
			case EntityTypes.TVQ:
				if (taskItem.status == "Pending Form Input") {
					this.completeForm(taskItem);
				}
				break;
			case EntityTypes.RightShipInspection:
				if (taskItem.status == "Inspection Required") {
					this.requestRSInspection(taskItem);
				}
				break;
			case EntityTypes.Vet:
				if (taskItem.status == "Awaiting Response" ||
					taskItem.status == "Review Required" ||
					taskItem.status == "Pending") {
					this.taskActionService.navigateToReplyToRfi(taskItem);
				}
				break;
		}
		taskItem.isLoading = false
	}

	getStatusTitle(taskItem: TaskModel) {
		if (taskItem.taskType == EntityTypes.PSC && taskItem.status == "Created" && !this.isRightShipUser && taskItem.informationMeta && taskItem.description) {
			let hasDef = JSON.parse(taskItem.informationMeta)['NumberOfDeficiencies'] > 0;
			let hasDet = taskItem.description.includes("Det: Yes");
			if (!(hasDef || hasDet)) 
				return "Clean";
		}
		return taskItem.status;
	}


	clickableStatus(taskItem: TaskModel) {
		switch (taskItem.taskType) {
			case EntityTypes.PSC:
			case EntityTypes.Incident:
				return taskItem.status == "Created" || taskItem.status == "Awaiting Response" || taskItem.status == "Review Required";
			case EntityTypes.GHGVerification:
				return taskItem.status == "Pending Ship Manager Input" || taskItem.status == "Awaiting Response" 
				|| taskItem.status == "Review Required" || taskItem.status == "Pending Ship Manager";
			case EntityTypes.TVQ:
				return taskItem.status == "Pending Form Input";
			case EntityTypes.RightShipInspection:
				return taskItem.status == "Inspection Required";
			case EntityTypes.Vet:
				return taskItem.status == "Awaiting Response" || taskItem.status == "Review Required";
		}
	}

	//Redirects to the appropriate page based on the task type.
	redirectToType(taskItem: TaskModel) {
		let entityId = taskItem.taskEntityId;
		switch (taskItem.taskType) {
			case EntityTypes.Vet:
				window.location.href = this.configService.config.urls.rightShipPlatformUrl + `/vet/${entityId}`;
				break;
			case EntityTypes.PSC:
				window.location.href = this.configService.config.urls.rightShipPlatformUrl + `/psc/${entityId}`;
				break;
			case EntityTypes.Incident:
				window.location.href = this.configService.config.urls.rightShipPlatformUrl + `/incident/${entityId}`;
				break;
			case EntityTypes.GHGVerification:
				window.location.href = this.configService.config.urls.rightShipPlatformUrl + `/environmental-review-request/${entityId}`;
				break;
			case EntityTypes.RightShipInspection:
				window.location.href = this.configService.config.urls.rightShipPlatformUrl + `/insp/${entityId}`;
				break;
			case EntityTypes.TVQ:
				window.location.href = this.configService.config.urls.rightShipPlatformUrl + `/vet-task-onboarding-custom-content?vesselApplicationFormId=${entityId}`;
				break;
		}
	}

	//Complete Form
	completeForm(task: TaskModel) {
		let landingPageGuid = task.meta.LandingPageGuid;
		let onboardingRequestGuid = task.meta.OnboardingRequestGuid;
		window.open(`${this.configService.config.urls.rightShipPlatformUrl}/OnboardingClient/${landingPageGuid}?onboardingRequestGuid=${onboardingRequestGuid}`, "_blank");
	}

	//Request an environmental review
	requestEnvironmentalReview(task: TaskModel) {
		window.open(`${this.configService.config.urls.rightShipPlatformUrl}/request-an-environmental-review?guid=${task.meta.Guid}`, "_blank");
	}

	//Request an RS Inspection
	requestRSInspection(task: TaskModel) {
		window.open(`${this.configService.config.urls.rightStoreUrl}/Product/rightship-inspection-booking?${this.getEnvQueryParam()}vesselId=${task.vesselId}`, "_blank");
	}

    getEnvQueryParam(isLast: boolean = false)
    {
        return this.configService.config.environment.toLowerCase() == "production" ? '' : `env=${this.configService.config.environment}${isLast? '': '&'}`;
    }

	nextClick(): void {
		throw new Error('Method not implemented.');
	}

	previousClick(): void {
		throw new Error('Method not implemented.');
	}
}
